import { useState, type SyntheticEvent } from 'react'
import { Box, Typography, Tab, Tabs } from '@mui/material'
import { CreditCard, Receipt, Calculate } from '@mui/icons-material'

import { useGetSubscriptionQuery, useGetUsageQuery, useGetInvoicesQuery } from '@/apis/billingApi'

import { BillingUsageTab } from './BillingUsageTab'
import { InvoiceHistoryTab } from './InvoiceHistoryTab'
import { PricingCalculator } from './PricingCalculator'

export function BillingPage() {
    const [tab, setTab] = useState(0)
    const { data: subscription } = useGetSubscriptionQuery()
    const { data: usage } = useGetUsageQuery()
    const { data: invoices = [] } = useGetInvoicesQuery()

    const handleTabChange = (_: SyntheticEvent, newValue: number) => {
        setTab(newValue)
    }

    return (
        <Box sx={{ p: 3 }}>
            <Typography variant="h5" sx={{ mb: 2 }}>
                Billing
            </Typography>

            <Tabs
                value={tab}
                onChange={handleTabChange}
                sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}
            >
                <Tab icon={<CreditCard />} iconPosition="start" label="Billing & Usage" />
                <Tab icon={<Receipt />} iconPosition="start" label="Invoices" />
                <Tab icon={<Calculate />} iconPosition="start" label="Pricing Calculator" />
            </Tabs>

            {tab === 0 && (
                <BillingUsageTab
                    subscription={subscription}
                    usage={usage}
                    goToInvoices={() => setTab(1)}
                />
            )}
            {tab === 1 && <InvoiceHistoryTab invoices={invoices} />}
            {tab === 2 && <PricingCalculator currency={usage?.currency ?? 'USD'} />}
        </Box>
    )
}
